'use client';
import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { useABTestVariant } from '../ABTest';
import {
  DE_LP_STORY_TELLING_V1_2_EXPERIMENT,
  DE_LP_STORY_TELLING_V1_2_EXPERIMENT_ID,
} from '@data/surveyConfigs';
import clsx from 'clsx';

interface LandingPageLayoutProps {
  children: React.ReactNode;
  showHeaderButton?: boolean;
  showHeaderButtonOnMobile?: boolean;
  showHeaderTagline?: boolean;
  showHeaderLogos?: boolean;
  hideHeaderOnScroll?: boolean;
  backgroundColor?: string;
  buttonText?: string;
}

export default function LandingPageLayout({
  children,
  showHeaderButton = false,
  showHeaderButtonOnMobile = true,
  showHeaderTagline = true,
  showHeaderLogos = true,
  backgroundColor,
  buttonText,
}: LandingPageLayoutProps) {
  const variant = useABTestVariant(DE_LP_STORY_TELLING_V1_2_EXPERIMENT.experiment);
  return (
    <div className="pageWrapper lp-rebrand">
      <Header showButton={showHeaderButton} showButtonOnMobile={showHeaderButtonOnMobile} buttonText={buttonText} showTagline={showHeaderTagline} showLogos={showHeaderLogos} />
      <main
        id="mainContent"
        className={clsx(
          'mainContent',
          variant === DE_LP_STORY_TELLING_V1_2_EXPERIMENT_ID.B && 'story-telling',
        )}
        style={{ backgroundColor }}
        aria-label="Content"
      >
        {children}
      </main>
      <Footer />
    </div>
  );
}
